export const ZhChsVideoStrings = {
  NO_ACTIVE_STREAMS: "没有直播"
}